import Plugin, { init } from "@/modules/_utils/Plugin";

class PaymentTab extends Plugin {
  init() {
    const tabTitle = document.querySelectorAll(
      ".payment__content-form_tab-title_item"
    );
    const tabContainer = document.querySelector(".payment__content-form_outer");

    function clickHandler(e) {
      let attrClass = this.getAttribute("data-active");
      switch (attrClass) {
        case "credit":
          tabContainer.classList.remove("cash--active");
          tabContainer.classList.add("credit--active");
          break;
        case "cash":
          tabContainer.classList.add("cash--active");
          tabContainer.classList.remove("credit--active");
          break;
      }
    }

    Array.prototype.forEach.call(tabTitle, function(radio) {
      radio.addEventListener("click", clickHandler);
    });
  }
}

export default init(PaymentTab, "paymentTab");
